/**
 * Only one submenu open at a time
 */
const linkItemSelector = '[data-subnav-toggle]';
const subMenuSelector = '[data-subnav]';

// Uncheck every linkItemSelector matching checkbox, except event.target
$(document).on('click', (event) => {
  const $target = $(event.target);

  // Only react if a menu is open
  if ($(`${linkItemSelector}:checked`).length > 0) {
    // Do nothing when target is submenu
    if ($target.closest(subMenuSelector).length > 0) {
      return;
    }

    // Close submenus
    $(linkItemSelector).prop('checked', false);

    // Stop propagation and default actions,
    // since we used this event to close navigatoin
    event.preventDefault();
    event.stopPropagation();
  }
});

// JQuery fires 2 click events when clicking on label with for attribut
// One for the label, the other for the input. So we need to stop this propagation
$(document).on('click', linkItemSelector, (event) => {
  event.stopPropagation();
});
